import { Component } from '@angular/core';

@Component({
  selector: 'one-title-bar',
  templateUrl: './title-bar.component.html'
})
export class TitleBarComponent {}
